export const getUnitUtilitiesQuery = (propertyIds, unitIds,
    startDate, endDate, utilityItems, offset) => {
    const query = `
    query{
        unitUtilities(
          propertyIds:${JSON.stringify(propertyIds)},
          unitIds:${JSON.stringify(unitIds)},
          startDate: ${ !startDate? JSON.stringify("") : JSON.stringify(startDate.format("YYYY-MM-DD"))},
          endDate: ${ !endDate? JSON.stringify("") : JSON.stringify(endDate.format("YYYY-MM-DD"))},
          utilityItems:${JSON.stringify(utilityItems)},
          offset:"${offset}",
          limit:50
        ){
          utilities{
            utilityId,
            updated,
            unit{
              id
            },
            date,
            item,
            previousReading,
            currentReading,
            invoice{
              id
              amount
            },
            createdTs
          }
          next,
          previous
        }
      }
    `;
    return query;
}


export const getPropertyUnitUtilitiesQuery = (propertyIds, unitIds, utilityItem) => {
  const query = `
    query{
      utilities(propertyIds: ${JSON.stringify(propertyIds)}, unitIds:${JSON.stringify(unitIds)}, utilityItem:"${utilityItem}"){
        id
        utilityId,
        updated,
        unit{
          id
        },
        date,
        item,
        previousReading,
        currentReading,
        invoice{
          id
        },
        createdTs

      }
    }
  `;
  return query;
}

export const addUtilitiesBulkQuery = (payload) => {
  const mutation = `
    mutation{
      addUtilitiesBulk(
        utilityItem: "${payload.utilityItem}",
        records: "${payload.recordsJsonString}",
        utilityRate: ${payload.utilityRate},
        invoiceDate: "${payload.invoiceDate}",
        ){
        unitUtilities{
          id
          utilityId,
          updated,
          unit{
            id
          },
          date,
          item,
          previousReading,
          currentReading,
          invoice{
            id
          },
          createdTs
        }
        invoices{
          tenantDetails{
              tenantId
              firstName
              lastName
              unitId
              propertyId
              archived
          }
          amount
          invoiceItem
          description
          paid
          createdTs
          invoiceDate
          status
          lastUpdated
          createdBy{
              id
          }
          message{
            id
            message
          }
        }
        errorMessage
      }
    }
    `;
  return mutation;
}


export const addUnitUtilityMutation = ( unitId,
    date, item,currentReading, previousReading, invoiceId) => {
    let previousReadingStr = "";
    if(previousReading != ""){
      previousReadingStr = `previousReading:${previousReading},`
    }
    const mutation = `
    mutation{
        addUnitUtility(
          unitId:${JSON.stringify(unitId)},
          date:"${date}",
          item:"${item}",
          currentReading:${currentReading},
          ${previousReadingStr}
          invoiceId:${JSON.stringify(invoiceId)}

        ){
          unitUtility{
            utilityId,
            updated,
            unit{
              id
            },
            date,
            item,
            previousReading,
            currentReading,
            invoice{
              id,
              invoiceItem
            },
            createdTs
          }
          errorMessage
        }
      }
        `;
        return mutation;
    }


export const updateUnitUtilityMutation = ( utilityId,  unitId,
    date, item,currentReading, previousReading, invoiceId) => {
      let previousReadingStr = "";
    if(previousReading != ""){
      previousReadingStr = `previousReading:${previousReading},`
    }
    const mutation = `
    mutation{
        updateUnitUtility(
            utilityId:"${utilityId}",
            unitId:${JSON.stringify(unitId)},
            date:"${date}",
            item:"${item}",
            currentReading:${currentReading},
            ${previousReadingStr}
            invoiceId:${JSON.stringify(invoiceId)}

        ){
            unitUtility{
            utilityId,
            updated,
            unit{
                id
            },
            date,
            item,
            previousReading,
            currentReading,
            invoice{
              id
              tenant{
                id
              }
              amount
              invoiceItem
              description
              paid
              createdTs
              invoiceDate
              status
              lastUpdated
              createdBy{
                  id
              }
            },
            createdTs
            }
            errorMessage
        }
        }
        `;
        return mutation;
    }

export const deleteUnitUtilityMutation = (utilityId) => {
    const mutation = `
    mutation{
        deleteUnitUtility(
          utilityId:"${utilityId}",
        ){
          success,
          errorMessage
        }

      }
    `;
    return mutation;
}

export const createUtilityInvoices = (utilityIds) => {
  const mutation = `
  mutation{
    createUtilityInvoices(utilityIds: ${JSON.stringify(utilityIds)}){
      utilities{
        utilityId,
        updated,
        unit{
          id
        },
        date,
        item,
        previousReading,
        currentReading,
        invoice{
          id
        },
        createdTs
      }
      invoices{
          id
          invoiceItem
      }
      errors
      feedbackSummary
    }
  }
  `
  return mutation
}

export const resetUtilitiesMutation = (payload) => {
  const mutation = `
  mutation{
    resetMeterReadings(
      unitIds:${JSON.stringify(payload.unitIds)},
      utilityItem:"${payload.utilityItem}"
    ){
      success,
      message
    }
  }
  `
  return mutation
}